// ANGEL FLIGHT — entry point (Three.js).
//
// Mounts the App (renderer + single rAF loop + screen routing) into #app and
// clears the boot splash. Opens on the main menu; ?dev=<missionId> (or ?dev=1)
// jumps straight into a mission for quick testing.

import { App } from './app/App';
import { Platform } from './platform';
import * as authClient from './auth';
import { mountPlatformChip } from './platform-chip';

const parent = document.getElementById('app');
if (!parent) throw new Error('ANGEL FLIGHT: #app mount point missing');

// Clear the pre-boot splash.
parent.querySelector('#boot-splash')?.remove();

const app = new App(parent);

// ── Shared strafe.games economy SDK (additive + DORMANT-SAFE) ───────────────
// With VITE_FEATURE_AUTH unset the SDK makes ZERO network calls: loadConfig()
// falls back to baked tunables, grantWelcomeBonusOnce() seeds the carried-over
// local balance, and the chip shows only that balance + the honest "everything
// free" note. The chip root is pointer-events:none (only its own pill captures
// input), so on this touch-aim game it can NEVER steal an aim tap. It is
// corner-anchored to dodge the HUD: bottom-left on desktop (clear of the top
// FLIR band), but top-right on TOUCH — bottom-left holds the FLARE button on
// touch, and top-right only grazes the PAYOUT readout (never a tappable control).
// mountPlatformChip never throws.
void Platform.loadConfig().finally(() => Platform.grantWelcomeBonusOnce());
const chipCorner: 'top-right' | 'bottom-left' =
  (typeof matchMedia !== 'undefined' && matchMedia('(pointer: coarse)').matches) ||
  (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0)
    ? 'top-right'
    : 'bottom-left';
mountPlatformChip({ platform: Platform, auth: authClient, corner: chipCorner });

const dev = new URLSearchParams(location.search).get('dev');
if (dev) {
  app.startMission(dev !== '1' ? dev : 'm1-overpass');
} else {
  app.showMenu();
}
